<template>
  <div class="hello">
    <GlobalHeader style="position: absolute;" :activeIndex="activeIndex" />
    <el-main>
      <div style="
                  position: fixed;
                  z-index: 111;
                  background: #fff;
                  width: calc(100% - 185px);
                " v-loading="loading" element-loading-text="拼命加载中" element-loading-spinner="el-icon-loading"
        element-loading-background="rgba(0, 0, 0, 0.8)">
        <div class="edit">
          <div class="fl" style="justify-content: space-between; margin-left: 6px">
            <span style="width: 69px; display: block" @click="cleanUpEvt">ALL</span>
          </div>

          <el-tooltip class="item" effect="dark" content="工资月份" placement="bottom">
            <el-date-picker style="width: 137px;margin-left: 6px;" v-model="value0" type="monthrange" align="right"
              unlink-panels range-separator="" start-placeholder="工资月份" end-placeholder=""
              :picker-options="pickerOptions" :class="{ 'your-css-class_box': !isValue3Empty_1 }" @change="getList">
            </el-date-picker>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="结算部门" placement="bottom">
            <el-select v-model="jsbm" filterable placeholder="结算部门" @change="jsbmChange" style="margin-left: 6px;"
              clearable :class="{ 'vip': jsbm && jsbm !== '结算部门' }">
              <el-option v-for="(value, key) in jsbm_one" :key="key" :label="value.name" :value="value.id">
              </el-option>
            </el-select>
          </el-tooltip>

          <el-tooltip class="item" effect="dark" content="项目名称" placement="bottom">
            <el-input placeholder="项目名称" v-model="project_name" style="margin-left: 6px;" clearable @change="getList">
            </el-input>
          </el-tooltip>


          <span style="margin-left: 5px" @click="excelEvt">EXCEL</span>
        </div>
        <div class="pagination_box">
          <span>项目产值划分：{{ totalRow_one.division }} </span>
          <span>项目回收金额：{{ totalRow_one.backed_amount }} </span>
          <span>项目成本：{{ totalRow_one.cost }} </span>
          <span>总工作量：{{ totalRow_one.quantities }} </span>
          <span>工作量产值：{{ totalRow_one.production }} </span>
          <span>成本产值比：{{ totalRow_one.value_ratio }} </span>
        </div>
        <div class="" style="width: 100%">
          <div class="pagination">
            <el-input v-model="paginationInput" style="width: 50px" size="mini" placeholder="To"
              @change="limitEvt"></el-input>
            <el-pagination @current-change="handleCurrentChange" :current-page.sync="currentPage1"
              :page-size="paginationInput - 0" layout="prev, pager, next, jumper" :total="total" :pager-count="5">
            </el-pagination>
          </div>
          <el-tabs>
            <el-table :data="tableData" border ref="sortTable" style="width: 100%" @cell-mouse-enter="huaguo"
              @sort-change="sortChangeEvt" @cell-click="idEvt" v-sort-orders="['descending', 'ascending', '']"
              :empty-text="dataLoaded ? '暂无数据' : '正在加载数据中...'">
              <el-table-column fixed label="年月" width="120" sortable="custom">
                <template slot-scope="props">
                  {{ props.row.year }}年{{ props.row.month }}月
                </template>
              </el-table-column>
              <el-table-column prop="jsbm" label="部门" width="120" sortable="custom">
              </el-table-column>
              <el-table-column prop="project_name" label="项目名称" width="400" sortable="custom">
                <template slot-scope="props">
                  <span class="white_over">{{ props.row.project_name }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="work_type" label="工种" width="120" >
              </el-table-column>
              <el-table-column prop="division" label="项目划分产值" width="120" sortable="custom">
                <template slot-scope="props">
                  <span @click="openChildDialog(2)"
                    :style="{ color: props.row.same == 'y' ? '#f00' : '#000', textDecoration: 'underline' , cursor: 'pointer' }">
                    {{ props.row.division }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="backed_amount" label="项目回款金额" width="120" sortable="custom">
                <template slot-scope="props">
                  <span :style="{ color: props.row.backed_amount == '0' ? '#fff' : '#000', }"> {{
                    props.row.backed_amount }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="cost" label="项目成本" width="120" sortable="custom">
              </el-table-column>
              <el-table-column prop="quantities" label="项目总工作量" width="120" sortable="custom">
                <template slot-scope="props">
                  <span @click="openChildDialog(2)"
                    :style="{ color: props.row.quantities_red == 'y' ? '#f00' : '#000', textDecoration: 'underline', cursor: 'pointer' }">
                    {{ props.row.quantities }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="production" label="工作量产值" width="120" sortable="custom">
              </el-table-column>
              <el-table-column prop="value_ratio" label="成本产值比" sortable="custom">
                <template slot-scope="props">
                  {{ props.row.value_ratio }}%
                </template>
              </el-table-column>
            </el-table>
          </el-tabs>
        </div>
      </div>
    </el-main>

    <pop_up ref="childComponentRef" />

  </div>
</template>

<script>

import pop_up from "@/components/pop_up.vue";
import GlobalHeader from '@/components/GlobalHeader.vue'
import { CostApi, SearchApi,  InfoApi } from "@/api/salary/index.js"


const delay = (function () {
  let timer = 0;
  return function (callback, ms) {
    clearTimeout(timer);
    timer = setTimeout(callback, ms);
  };
})();
export default {
  components: {
    GlobalHeader,
    pop_up
  },
  data() {
    return {
      activeIndex: "4-4",
      tableData: [],
      input1: null,
      pickerOptions: {
        shortcuts: [{
          text: '本月',
          onClick(picker) {
            picker.$emit('pick', [new Date(), new Date()]);
          }
        }, {
          text: '今年至今',
          onClick(picker) {
            const end = new Date();
            const start = new Date(new Date().getFullYear(), 0);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近六个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setMonth(start.getMonth() - 6);
            picker.$emit('pick', [start, end]);
          }
        }]
      },
      order: null,
      orField: null,
      value0: '',
      isValue3Empty_1: true,
      totalRow_one:[],
      loading:false,
      project_name:null,
      jsbm: null,
      jsbm_one:null,
      dataLoaded: false, // 表格数据是否加载完成的状态
      selectedId:null,

      account_out_name:null,
      realname:null,
      currentPage1:1,
      total: null,
      paginationInput: null,
    };
  },
  created() {
    this.loading = true
    CostApi().then((res => {
      this.tableData = res.data.projects;
      this.totalRow_one = res.data.total;
      this.total = res.data.total.total,
      this.paginationInput = res.data.limit
      this.currentPage1 = res.page - 0;
       this.loading = false;
    }))

    SearchApi().then((res) => {
      this.jsbm_one = res.data.jsbm
    })
  },
  mounted() {
    window.addEventListener("scroll", (e) => this.imgScrollEvt(e), true);
  },
  methods: {

    limitEvt() {
      this.getList();
    },

    showTab(tab) {
      this.activeTab = tab;
    },
    //分页
    handleCurrentChange(res) {
      this.loading = true
      setTimeout(() => {
        this.getList();
        this.loading = false
      }, 100)
    },



    jsbmChange(value) {
      this.jsbm = value;
      this.getList()
    },
    accountChange(value) {
      this.staff_one = value;
    },
    ACEChange(value) {
      this.role_one = value
    },


    account_inChange(value) {
      this.staff_one = value;
    },
    currency_inChange(value) {
      this.currency_in_name = value;
      this.getList()
    },
    currency_outChange(value) {
      this.currency_out_name = value;
      this.getList()
    },






    //滑动事件
    imgScrollEvt(e) {
      var e =
        document.documentElement.scrollTop ||
        window.pageYOffset ||
        e ||
        document.body.scrollTop;
      //点击分页 滚动条为0
      if (this.pagefenye == true) {
        e.scrollTop = 0;
        this.pagefenye = false
        return
      }
    },
    //列表排序
    sortChangeEvt(row) {
      if (row.order == "ascending") {
        this.order = "asc";
        this.orField = row.prop;
      } else if (row.order == "descending") {
        this.order = "desc";
        this.orField = row.prop;
      } else if (row.order == null) {
        this.order = "";
        this.orField = '';
      }
      this.getList();
    },

    huaguo(row, column, cell, event) {
      this.selectedId = row.project_id
    },
    idEvt(row, column, cell, event) {
      this.selectedId = row.project_id
    },

     openChildDialog(type) {
        if (type == 2) {
        InfoApi({
          id: this.selectedId
        }).then((res) => {
          if (res.code == 1000) {
            this.resData = res.data
            this.$refs.childComponentRef.openDialog(this.resData);
          }
        });
        }
    },

    //微信
    bankChange(value) {
      this.wechat_one = value;
    },

    //获取页面数据
    getList() {
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      // //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let data = {
        orField: this.orField,
        orWhere: this.order,
        project_name:this.project_name,
        jsbm:this.jsbm,
        start: income_time_start ? income_time_start : '',
        end: income_time_end ? income_time_end : '',
        page: this.currentPage1,
        limit: this.paginationInput,
      };
      this.loading = true
      CostApi(data).then((res => {
        this.tableData = res.data.projects;
        this.totalRow_one = res.data.total;
        this.total = res.data.total.total,
        this.loading = false;
        this.dataLoaded = true; // 表格数据是否加载完成的状态
      }))
    },
    excelEvt(){
      //入职时间
      let date4 = {
        start: this.value0[0],
        end: this.value0[1],
      };
      // //入职时间
      var income_time_start = Math.floor(date4.start / 1000);
      var income_time_end = Math.floor(date4.end / 1000);

      // 将选定的结束日期的时间设置为当天的最后一秒
      var lastDate4 = new Date(income_time_end * 1000);
      lastDate4.setHours(23, 59, 59);
      //离职时间
      income_time_end = Math.floor(lastDate4.getTime() / 1000);
      let data = {
        orField: this.orField,
        orWhere: this.order,
        project_name: this.project_name,
        jsbm: this.jsbm,
        start: income_time_start ? income_time_start : '',
        end: income_time_end ? income_time_end : '',
        excel:1,
      };
        this.loading = true
       let genExcel = false;
      if (genExcel == false) {
        CostApi(data).then((res) => {
          this.loading = false
          window.location.href = res
          genExcel = true
        });
      } else if (genExcel == true) {
        alert('正在生成数据请勿重复请求')
      }
    },

    //清除数据
    cleanUpEvt() {
      this.project_name  = '';
      this.value0 = '';
      this.jsbm = '';

      this.$refs.sortTable.clearSort();
      this.loading = true

      CostApi().then((res => {
          this.tableData = res.data.projects;
          this.totalRow_one = res.data.total;
          this.total = res.data.total.total,
          this.currentPage1 = res.page - 0;
          this.paginationInput = res.data.limit
          this.loading = false;
      }))
    },


  },
  watch: {
    'value0': function (newVal, oldVal) {
      this.isValue3Empty_1 = !newVal;
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
@import url("../../../style/transfer.less");



/* 固定左侧的项目管理列表 */
.el-aside {
  position: fixed;
  top: 50px;
  /* 顶部Header的高度，根据你的实际Header高度调整 */
  left: 0;
  width: 155px;
  height: 100%;
  /* 使其充满整个可视区域的高度 */
  z-index: 99;
  /* 使其在正文内容之上 */
}

.el-main {
  left: 185px;
  /* 与左侧项目管理列表的宽度保持一致 */
  padding: 0px;
  /* 添加一些内边距，使内容不紧贴在边缘 */
  top: 60px;
  position: relative;
}

/deep/.el-submenu__title {
  height: 39px !important;
  line-height: 39px !important;
  list-style: none;
}


.edit {
  // width: 1000px;
  height: 40px;
  display: flex;

  div {
    width: 137px;
    height: 26px;
    cursor: pointer;
  }

  .el-input {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
  }

  span {
    width: 69px;
    height: 26px;
    font-size: 12px;
    border: 1px solid #589ff9;
    line-height: 26px;
    color: #589ff9;
    border-radius: 3px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  /deep/.el-input__inner {
    height: 26px;
    line-height: 26px;
    cursor: pointer;
    font-size: 12px;
    padding-left: 10px;
  }

  /deep/.el-input__icon {
    line-height: 0px;
  }
}


/deep/.el-table th.el-table__cell {
  background: #dce6ee;
}

.pagination_box {
  min-width: 500px;
  font-size: 14px;
  display: flex;
  // align-items: center;
  justify-content: flex-start;
  position: absolute;
  left: 1px;
  z-index: 123;
  cursor: pointer;
  span{
    padding:0 20px;
  }
}

.pagination{
  min-width: 500px;
  font-size: 14px;
  display: flex;
  // align-items: center;
  justify-content: flex-start;
  position: absolute;
  right: 1px;
  z-index: 123;
  cursor: pointer;

}


/deep/.el-tabs--border-card {
  border: none;
}

/deep/.el-tabs--border-card>.el-tabs__content {
  padding: 0 !important;
}

/deep/.el-table__body-wrapper {
  overflow-y: auto;
}

/deep/.el-table__footer-wrapper {
  position: fixed;
  top: 145px;
  z-index: 111;
  height: 49px;
  background-color: #fff;
  width: calc(100% - 178px);
}

.mainx {
  margin-top: 50px;
}

/deep/.el-table th.el-table__cell {
  background: #f5f7fa;
}

/deep/.el-tabs__header {
  width: 100%;
}

/deep/.el-table__footer-wrapper .gutter {
  background: #f5f7fa;
  border-top: 1px solid #ebeef5;
  border-bottom: 1px solid #ebeef5;
}


/* 添加一个新的类来将总计行移动到最上方 */
.move-top .el-table__summary-cell {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  /* 根据需要调整背景颜色、字体样式等 */
}

/deep/.el-table__fixed-footer-wrapper {
  display: none;
}

/deep/.el-badge__content.is-fixed {
  display: none;
}

/deep/.el-tabs__item {
  border-radius: 3px 3px 0px 0px;
  background: #d9d9d9;
  margin-left: 4px;
  color: #979797;
  font-size: 12px;
}

/deep/.el-tabs__active-bar {
  display: none;
}

/deep/.el-tabs__item {
  padding: 0;
  width: 105px;
  height: 32px;
  line-height: 32px;
}

/deep/.el-tabs__item.is-active {
  background: #fff;
  border: 1px solid #d9d9d9;
  color: #000;
  border-bottom: none;
}

/deep/.el-table__footer-wrapper tbody td.el-table__cell {
  background: #fff;
  border: none;
}

/deep/ .el-table__footer-wrapper .gutter {
  background: #fff !important;
}

//修改tabs的下划线 以及颜色
/deep/.el-tabs__nav-wrap::after {
  height: 0;
  border: 1px solid #d9d9d9;
}

/deep/.el-tabs__nav {
  transform: translateY(1px) !important;
}

/deep/.el-table th.el-table__cell>.cell {
  color: #333333;
  font-size: 12px;
  height: 23px;

}

/deep/.el-table td.el-table__cell div {
  font-size: 14px;
}

/deep/::placeholder {
  color: #59565a;
  /* 这里替换为你想要的颜色值 */
  margin-left: 5px !important;
}



.maxs {
  background: #f00 !important;
}

/deep/.el-dialog__body {
  padding: 0 !important;
}

/deep/.el-collapse-item {
  width: 490px !important;
}


/deep/.vip .el-input__inner {
  background-color: #bcd9f8d4 !important;
}

//日期选择背景色改变
.your-css-class_box {
  background-color: #bcd9f8d4 !important;
}

//调整下拉选择input
.el-cascader {
  line-height: 25px;
  margin-left: 6px
}

.el-cascader /deep/.el-input__inner {
  height: 27px !important;
  min-width: 137px !important;
}


//溢出隐藏
.white_over {
  white-space: nowrap;
  overflow: hidden;
}



/deep/.el-form-item__label {
  font-size: 12px;
  padding: 0px;
}

/deep/.el-dialog__header {
  background: #D9D9D9;
}

/deep/.el-dialog__body {
  background: #D9D9D9;
}


.whole {
  width: 100%;
  height: 450px;
  display: flex;

  /deep/.el-input {
    width: 280px;
  }
}

.banner {
  width: 78%;
  margin-left: 380px;
  height: 835px;
  // overflow: auto;
  padding-right: 7px;
}


.Completion_status {
  margin-top: 10px;
  border: 1px solid #d9d9d9;
  border-radius: 3px;
  background: #fff;
  border-radius: 5px;
  word-wrap: break-word;
  display: flex;
  flex-direction: column;

  /deep/.el-input__inner {
    width: 280px !important;
    border-radius: 5px;
    border: 0.5px solid #D9D9D9;
    height: 30px;
  }

  /deep/.el-input--suffix {
    width: 300px !important;
  }
}

/deep/.el-form-item__label {
  padding: 0px;
  font-size: 12px;
  color: #333;
}



// 删除和保存的样式
.cloneEvt {
  display: flex;
  height: 24px;

  span:nth-child(1) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #3383EA;
    font-size: 12px;
    color: #fff;
    margin-right: 10px;
  }

  span:nth-child(2) {
    display: flex;
    width: 70px;
    padding: 5px 20px;
    justify-content: center;
    align-items: center;
    border-radius: 3px;
    background: #979797;
    font-size: 12px;
    color: #fff;
  }
}

.text_box_one {
  width: 282px;
  height: 150px;
  border-radius: 5px;
  border: 0.5px solid #D9D9D9;
}

.text_one {
  /deep/.el-form-item__content {
    margin-bottom: -10px;
  }
}


.content {
  border: 1px solid #D9D9D9;
  border-radius: 5px;
  height: 801px;

  p:nth-child(1) {
    text-align: right;
    margin-right: 150px;
  }

  p:nth-child(2) {
    text-align: right;
    margin-right: 135px;
  }

  /deep/ .el-table__fixed-body-wrapper {
    overflow: hidden !important;
  }
}

.white_over {
  white-space: nowrap;
  overflow: hidden;
}
</style>
<style>
/* 日期选择背景色改变 */

.your-css-class_box .el-range-input {
  background-color: #8fc6ff00 !important;
}

/* 日期选择 第四个位置间距拉开 */
.el-picker-panel__sidebar button:nth-child(4) {
  margin-bottom: 20px;
}

.el-tooltip__popper.is-dark {
  background-color: #589ff9 !important;
}

.el-tooltip__popper .popper__arrow {
  display: none !important;
}
</style>



// WEBPACK FOOTER //
// src/src/salary_management/Monthly_department/index.vue